export const userAuthenticationTypes = ["EMAIL", "GOOGLE", "FACEBOOK", "TIKTOK"] as const;

export const USER_AUTHENTICATION_TYPES = {
  EMAIL: "EMAIL",
  GOOGLE: "GOOGLE",
  FACEBOOK: "FACEBOOK",
  TIKTOK: "TIKTOK",
} as const;

export const USER_REGISTRATION_CONTEXT = {
  REGULAR: "regular",
  PURCHASE: "purchase",
  ADMIN_INVITE: "admin_invite",
} as const;

export type UserAuthenticationType =
  (typeof USER_AUTHENTICATION_TYPES)[keyof typeof USER_AUTHENTICATION_TYPES];

export type UserRegistrationContext =
  (typeof USER_REGISTRATION_CONTEXT)[keyof typeof USER_REGISTRATION_CONTEXT];
